import React, { useState } from 'react';
import Collapse from '@material-ui/core/Collapse';

import PolicyRowMainBody from './PolicyRowMainBody';
import PolicyRowAdvancedOptions from './PolicyRowAdvancedOptions';
import PolicyRowBodyFooter from './PolicyRowBodyFooter';

import styles from './CssModules/PolicyRow.module.css';

const PolicyRowBody = ({
    policyBodyData,
    setPolicyBodyData,
    validatePolicyData,
    setStateAndSavePolicy,
    handleDeletePolicy,
    handleDiscardChanges,
    policyConfiguration,
    setPolicyConfiguration,
    isEditor,
    onFieldChanged,
    isDirty,
    setIsDirty,
    isMfaWindowEveryTime,
    setIsMfaWindowEveryTime,
    mfaWindowType,
    setMfaWindowType,
    mfaWindowValueByType,
    setMfaWindowValueByType,
    nextPolicyGroupId,
    setNextPolicyGroupId,
    isCreateFromLogs,
    isCreateFromTemplate,
    onEditTemplate,
    templateToEdit = undefined
}) => {
    // General states
    const [showAdvancedOptions, setShowAdvancedOptions] = useState(false);

    const isAllApplicationsSelected = (policyData) => {
        if (policyData && policyData.id >= 0) {
            if (policyData.relying_parties_enabled || policyData.ping_fed_enabled) {
                return !(policyData.relying_parties || []).some((app) => !app.excluded);
            } else if (policyData.okta_enabled) {
                return !(policyData.cloud_apps || []).some((app) => !app.excluded);
            }
        }
        return false;
    };

    const [selectAllApplications, setSelectAllApplications] = useState(isAllApplicationsSelected(policyBodyData));

    const toggleShowAdvancedOptions = (state) => {
        if (state !== undefined) {
            setShowAdvancedOptions(state);
        } else {
            setShowAdvancedOptions(!showAdvancedOptions);
        }
    };

    const onDiscardChangesClicked = () => {
        const newPolicyData = handleDiscardChanges();
        setSelectAllApplications(isAllApplicationsSelected(newPolicyData));
        return newPolicyData;
    };
    return (
        <div className={`${styles.policyBody} ${isEditor ? '' : styles.disabled}`}>
            {!policyBodyData.isValid && <div className={styles.policyLoadingError}>Error loading policy data</div>}
            {policyBodyData.isValid && (
                <>
                    <PolicyRowMainBody
                        policyBodyData={policyBodyData}
                        setPolicyBodyData={setPolicyBodyData}
                        policyConfiguration={policyConfiguration}
                        onFieldChanged={onFieldChanged}
                        toggleShowAdvancedOptions={toggleShowAdvancedOptions}
                        setIsDirty={setIsDirty}
                        isEditor={isEditor}
                        selectAllApplications={selectAllApplications}
                        setSelectAllApplications={setSelectAllApplications}
                    />
                    <Collapse in={showAdvancedOptions}>
                        <PolicyRowAdvancedOptions
                            policyBodyData={policyBodyData}
                            policyConfiguration={policyConfiguration}
                            setPolicyConfiguration={setPolicyConfiguration}
                            onFieldChanged={onFieldChanged}
                            isMfaWindowEveryTime={isMfaWindowEveryTime}
                            setIsMfaWindowEveryTime={setIsMfaWindowEveryTime}
                            mfaWindowType={mfaWindowType}
                            setMfaWindowType={setMfaWindowType}
                            mfaWindowValueByType={mfaWindowValueByType}
                            setMfaWindowValueByType={setMfaWindowValueByType}
                            nextPolicyGroupId={nextPolicyGroupId}
                            setNextPolicyGroupId={setNextPolicyGroupId}
                        />
                    </Collapse>
                </>
            )}

            <PolicyRowBodyFooter
                validatePolicyData={() => validatePolicyData(selectAllApplications)}
                setStateAndSavePolicy={setStateAndSavePolicy}
                handleDiscardChanges={onDiscardChangesClicked}
                handleDeletePolicy={handleDeletePolicy}
                policyBodyData={policyBodyData}
                isDirty={isDirty}
                isCreateFromLogs={isCreateFromLogs}
                isCreateFromTemplate={isCreateFromTemplate}
                templateToEdit={templateToEdit}
                onEditTemplate={onEditTemplate}
            />
        </div>
    );
};

export default PolicyRowBody;
